import { lazy } from 'react'

export const ProductPageAsync = lazy(() => import('./ProductPage'))
